import stopword from 'stopword'

export function sanitize(input: string): string {
  return removeExtraWhitespaces(
    removeNonAlphanumeric(removeStopwords(input))
  ).trim()
}

export function removeStopwords(input: string): string {
  return stopword.removeStopwords(input.split(' ')).join(' ')
}

/**
 * Note that it doesn't remove hyphen and single quote by design-these characters can be found inside a ts vector so it makes sense to leave them
 */
export function removeNonAlphanumeric(input: string): string {
  return input.replace(/[^0-9A-Za-zÀ-ÖØ-öø-ÿ \-']/g, '')
}

export function removeExtraWhitespaces(input: string): string {
  return input.replace(/\s\s+/g, ' ')
}

// Regex origin:
// https://gist.github.com/dperini/729294
// and https://mathiasbynens.be/demo/url-regex (this one is diegoperini's regex)
const URL_REGEXP =
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/
const HREF_URL_REGEXP =
  /href="((?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?)"/g

export enum LINK_SEARCH_MODE {
  PLAIN_TEXT,
  HTML_TEXT
}

export function isStringUrl(text: string): boolean {
  const isUrl = text.match(URL_REGEXP)
  if (!isUrl || isUrl.length !== 1) {
    return false
  }
  return true
}

export function searchLinksInText(
  text: string,
  mode: LINK_SEARCH_MODE = LINK_SEARCH_MODE.PLAIN_TEXT
): Array<string> {
  let links: Array<string> = []
  if (mode === LINK_SEARCH_MODE.PLAIN_TEXT) {
    // Split text by whitespace characters to create array of text tokens. Every token is tested separately.
    // Do not change this. Searching URLs using regexp in whole text string
    // is more error prone and detects less correct URLs and some wrong URLs detects as correct.
    const tokens = text.match(/[^\s]+/g)
    if (tokens) {
      links = tokens.filter((token) => {
        return URL_REGEXP.test(token)
      })
    }
  }

  if (mode === LINK_SEARCH_MODE.HTML_TEXT) {
    const htmlLinks = [...text.matchAll(HREF_URL_REGEXP)]
    links = htmlLinks.map((htmlLink) => {
      return htmlLink[1]
    })
  }

  return links
}
